import "./OrderListComponent.scss";
import equityActiveOrderListTemplate from "./EquityActiveOrderListComponent.html";
import equityInactiveOrderListTemplate from "./EquityInactiveOrderListComponent.html";
import mobileActiveOrderListTemplate from "./MobileActiveOrderListComponent.html";
import mobileInactiveOrderListTemplate from "./MobileInactiveOrderListComponent.html";
import optionActiveOrderListTemplate from "./OptionActiveOrderListComponent.html";
import optionInactiveOrderListTemplate from "./OptionInactiveOrderListComponent.html";
import {IComponentOptions} from "angular";
import {isTmcOrderViewModel} from "../../models/OrderViewModel";
import {OrderService} from "../../services/OrderService";
import {PlaceOrderService} from "../../../portfolio/templates/ticket/services/PlaceOrderService";
import {BaseStrategy, Strategy} from "../../../portfolio/templates/ticket/types/WhatIf";
import {isIressOrderModel} from "app/orders/models/iress/IressOrderViewModel";
import {isSimulatedOrderModel} from "app/orders/models/simulated/SimulatedOrderViewModel";
import {OrderSide} from "../../models/OrderRecord";
import {OrderListViewModel, OrderListViewModels} from "./models/OrderListViewModel";

export const EquityActiveOrderList = "tfEquityActiveOrderList";
export const EquityInactiveOrderList = "tfEquityInactiveOrderList";
export const MobileActiveOrderList = "tfMobileActiveOrderList";
export const MobileInactiveOrderList = "tfMobileInactiveOrderList";
export const OptionActiveOrderList = "tfOptionActiveOrderList";
export const OptionInactiveOrderList = "tfOptionInactiveOrderList";

export function equityActiveOrderList(): IComponentOptions {
    return {
        template: equityActiveOrderListTemplate,
        bindings: {
            orders: "<"
        },
        controllerAs: "ctrl",
        controller: OrderListComponentController
    };
}

export function equityInactiveOrderList(): IComponentOptions {
    return {
        template: equityInactiveOrderListTemplate,
        bindings: {
            orders: "<"
        },
        controllerAs: "ctrl",
        controller: OrderListComponentController
    };
}

export function mobileActiveOrderList(): IComponentOptions {
    return {
        template: mobileActiveOrderListTemplate,
        bindings: {
            orders: "<"
        },
        controllerAs: "ctrl",
        controller: OrderListComponentController
    };
}

export function mobileInactiveOrderList(): IComponentOptions {
    return {
        template: mobileInactiveOrderListTemplate,
        bindings: {
            orders: "<"
        },
        controllerAs: "ctrl",
        controller: OrderListComponentController
    };
}

export function optionActiveOrderList(): IComponentOptions {
    return {
        template: optionActiveOrderListTemplate,
        bindings: {
            orders: "<"
        },
        controllerAs: "ctrl",
        controller: OrderListComponentController
    };
}

export function optionInactiveOrderList(): IComponentOptions {
    return {
        template: optionInactiveOrderListTemplate,
        bindings: {
            orders: "<"
        },
        controllerAs: "ctrl",
        controller: OrderListComponentController
    };
}

export class OrderListComponentController {

    /** @input */
    public readonly orders: OrderListViewModels;

    /** @ngInject */
    public constructor(private readonly orderService: OrderService,
                       private readonly placeOrderService: PlaceOrderService) {
    }

    public replaceOrder(model: OrderListViewModel) {
        if (isTmcOrderViewModel(model.order)) {
            const trades: Array<BaseTrade> = model.order.legs.map((leg) => {
                return {
                    code: leg.code,
                    quantity: leg.ratio * (leg.side === OrderSide.BUY ? 1 : -1)
                };
            });
            const whatIf: Strategy = {
                name: `Replace ${model.code}`,
                tmc: true,
                trades,
                scaleFactor: model.quantity
            };
            this.placeOrderService.openOrderWindow(whatIf,
                                                   model.account?.id,
                                                   undefined,
                                                   undefined,
                                                   new Date());
        } else {
            const trade: BaseTrade = {
                code: model.code,
                quantity: model.quantity * (model.side === OrderSide.BUY ? 1 : -1)
            };
            const whatIf: BaseStrategy = {
                name: `Replace ${model.code}`,
                tmc: false,
                trades: [trade]
            };
            this.placeOrderService.openOrderWindow(whatIf,
                                                   model.account?.id,
                                                   undefined,
                                                   undefined,
                                                   new Date());
        }
    }

    public async cancelOrder(model: OrderListViewModel) {
        const order = model.order;
        if (isIressOrderModel(order)) {
            this.orderService.cancelOrder(order.serverName, order.orderNumber);
        } else if (isSimulatedOrderModel(order)) {
            this.orderService.cancelSimulatedOrder(order.id);
        } else {
            throw Error(`Unable to handle Order type ${typeof model}`);
        }
    }
}
